// Removes diacritics and capitalization of a given string
const normalize = (str: string): string => {
    return str
        .normalize('NFD') // Breaks characters with accents into base character + combining "accent"
        .replace(/[\u0300-\u036f]/g, '') // Removed combining "accents"
        .toLowerCase();
};

const isNullOrWhiteSpace = (str: string | null): boolean => {
    return str == null || (/^\s*$/.exec(str)) !== null;
};

export {
    normalize,
    isNullOrWhiteSpace,
};
